// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import {
  createOrderCommentResponseTransformer,
  getExperienceResponseTransformer,
  getTravelerOrderResponseTransformer,
  getTravelerReferredPromoCodesResponseTransformer,
  getUserPromoCodesResponseTransformer,
  listTravelerOrdersResponseTransformer,
  orderCommentsListResponseTransformer,
  updateOrderCommentResponseTransformer,
} from './transformers.gen';
import type {
  CreateOrderCommentData,
  CreateOrderCommentResponses,
  GetExperienceData,
  GetExperienceResponses,
  GetTravelerOrderData,
  GetTravelerOrderResponses,
  GetTravelerReferredPromoCodesData,
  GetTravelerReferredPromoCodesResponses,
  GetUserData,
  GetUserPromoCodesData,
  GetUserPromoCodesResponses,
  GetUserResponses,
  ListTravelerOrdersData,
  ListTravelerOrdersResponses,
  OrderCommentsListData,
  OrderCommentsListResponses,
  UpdateOrderCommentData,
  UpdateOrderCommentResponses,
} from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<
  TData,
  ThrowOnError
> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Получить данные об экскурсии
 */
export const getExperience = <ThrowOnError extends boolean = false>(
  options: Options<GetExperienceData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetExperienceResponses, unknown, ThrowOnError>({
    responseTransformer: getExperienceResponseTransformer,
    url: '/api/web/v1/experiences/{experience_id}/',
    ...options,
  });

/**
 * Get user data
 */
export const getUser = <ThrowOnError extends boolean = false>(options?: Options<GetUserData, ThrowOnError>) =>
  (options?.client ?? client).post<GetUserResponses, unknown, ThrowOnError>({ url: '/api/web/v1/me/', ...options });

/**
 * Получить все заказы путешественника
 */
export const listTravelerOrders = <ThrowOnError extends boolean = false>(
  options?: Options<ListTravelerOrdersData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ListTravelerOrdersResponses, unknown, ThrowOnError>({
    responseTransformer: listTravelerOrdersResponseTransformer,
    url: '/api/web/v1/orders/',
    ...options,
  });

export const orderCommentsList = <ThrowOnError extends boolean = false>(
  options: Options<OrderCommentsListData, ThrowOnError>,
) =>
  (options.client ?? client).get<OrderCommentsListResponses, unknown, ThrowOnError>({
    responseTransformer: orderCommentsListResponseTransformer,
    url: '/api/web/v1/orders/{order_id}/comments/',
    ...options,
  });

export const createOrderComment = <ThrowOnError extends boolean = false>(
  options: Options<CreateOrderCommentData, ThrowOnError>,
) =>
  (options.client ?? client).post<CreateOrderCommentResponses, unknown, ThrowOnError>({
    responseTransformer: createOrderCommentResponseTransformer,
    url: '/api/web/v1/orders/{order_id}/comments/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Обновить комментарий к заказу
 */
export const updateOrderComment = <ThrowOnError extends boolean = false>(
  options: Options<UpdateOrderCommentData, ThrowOnError>,
) =>
  (options.client ?? client).patch<UpdateOrderCommentResponses, unknown, ThrowOnError>({
    responseTransformer: updateOrderCommentResponseTransformer,
    url: '/api/web/v1/orders/{order_id}/comments/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Получить заказ путешественника
 */
export const getTravelerOrder = <ThrowOnError extends boolean = false>(
  options: Options<GetTravelerOrderData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetTravelerOrderResponses, unknown, ThrowOnError>({
    responseTransformer: getTravelerOrderResponseTransformer,
    url: '/api/web/v1/traveler-orders/{id}/',
    ...options,
  });

/**
 * Получить все промокоды путешественника
 */
export const getUserPromoCodes = <ThrowOnError extends boolean = false>(
  options?: Options<GetUserPromoCodesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetUserPromoCodesResponses, unknown, ThrowOnError>({
    responseTransformer: getUserPromoCodesResponseTransformer,
    url: '/api/web/v1/traveler-promo-codes/',
    ...options,
  });

/**
 * Получить реферальные промокоды путешественника
 */
export const getTravelerReferredPromoCodes = <ThrowOnError extends boolean = false>(
  options?: Options<GetTravelerReferredPromoCodesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetTravelerReferredPromoCodesResponses, unknown, ThrowOnError>({
    responseTransformer: getTravelerReferredPromoCodesResponseTransformer,
    url: '/api/web/v1/traveler-referred-promo-codes/',
    ...options,
  });
